import { useEffect, useState, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AppContext } from "../../../Context/Context";
import { reloadApp } from "../../../util/helper/helperFunctions";
import "../../../assets/css/SiteSelection/SiteSelectionPopup.css";

const SiteSelectionPopup = ({ location: { name, state, code, timeZone } }) => {
  const navigate = useNavigate();
  const { setLocationCode } = useContext(AppContext);

  const [buttonState, setButtonState] = useState("site-unselected-button");
  const [buttonText, setButtonText] = useState("Select");
  const { plantCode: activePlantCode } = useParams();

  useEffect(() => {
    if (code === activePlantCode) {
      setButtonState("site-selection-button");
      setButtonText("Selected");
    } else {
      setButtonState("site-unselected-button");
      setButtonText("Select");
    }
  }, [code, activePlantCode]);

  const updateLocation = () => {
    setLocationCode(code);
    setButtonText("Selected");
    navigate(`/${code}`, { replace: true });
    reloadApp();
  };

  return (
    <div className="site-selection-popup" id="siteSelectionPopupDivId">
      <div className="site-left-section">
        <p className="location">{code}</p>
        <p className="location-state">{state}</p>
      </div>
      <div className="site-right-section">
        <button
          disabled={buttonText === "Selected"}
          onClick={updateLocation}
          id="updateLocationButton"
          className={buttonState}
        >
          {buttonText}
        </button>
      </div>
    </div>
  );
};

export default SiteSelectionPopup;
